import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBell } from 'react-icons/fa';
import { useRealKmClient } from '../lib/useRealKmClient.js';

/* ═══════════════════════════════════════════════════════════
   Campanella avvisi HR (22/09) — colma il gap segnalato dal README:
   "La notifica a Sales/HR... non è realizzata: va deciso il canale con
   cui recapitarla" — il backend rileva (job giornaliero alle 06:15,
   scan-esperienze-in-scadenza) ma non ha mai un canale di consegna reale
   verso l'utente. Questo componente È quel canale, lato nostro: stessa
   logica di calcolo di EsperienzeInScadenzaPage.jsx (non l'endpoint di
   notifica puntuale, che segnala solo nei giorni esatti configurati —
   qui serve un conteggio sempre corretto, non un lampo).

   Solo per HR/Admin (Specifica v1.1 §4.2: "esperienze" è nell'accesso
   HR) — Sales/Management non vedono questa campanella, non è nel loro
   ambito secondo la matrice ruoli.

   Costo della chiamata (22/09, aggiornato dopo il fix di Monaco): GET
   /esperienze ora include già data_chiusura_prevista/data_fine_dichiarata/
   data_riferimento_chiusura nella lista — l'N+1 (dettaglio per ciascuna
   esperienza aperta) non serve più, una sola chiamata basta a prescindere
   da quante esperienze ci siano. La cache sotto resta comunque utile
   (evita di richiamare l'endpoint a ogni cambio pagina), ma non è più
   l'unica protezione contro un costo che cresce con i dati. */

let cacheConteggio = { valore: null, scadenza: 0 };
const CACHE_TTL_MS = 5 * 60 * 1000;

async function calcolaConteggio(kmClient) {
  const ora = Date.now();
  if (cacheConteggio.valore !== null && ora < cacheConteggio.scadenza) {
    return cacheConteggio.valore;
  }
  const lista = await kmClient.get('/esperienze', { query: { stato: 'aperta', limite: 200 } });
  const oggi = new Date();
  const n = (lista?.esperienze || [])
    // 28/09: governa la data PREVISTA (AF v2.0 UC-P03-02), non la dichiarata.
    .filter((e) => e.stato === 'aperta' && e.data_chiusura_prevista)
    .filter((e) => Math.ceil((new Date(e.data_chiusura_prevista) - oggi) / 86400000) <= 30)
    .length;
  cacheConteggio = { valore: n, scadenza: ora + CACHE_TTL_MS };
  return n;
}

export default function HrEsperienzeBell({ userRole }) {
  const kmClient = useRealKmClient();
  const navigate = useNavigate();
  const [conteggio, setConteggio] = useState(cacheConteggio.valore);

  const abilitato = userRole === 'hr' || userRole === 'admin';

  useEffect(() => {
    if (!abilitato) return;
    let cancellato = false;
    calcolaConteggio(kmClient)
      .then((n) => { if (!cancellato) setConteggio(n); })
      .catch(() => { if (!cancellato) setConteggio(null); });
    return () => { cancellato = true; };
  }, [abilitato, kmClient]);

  if (!abilitato) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/knowledge-management/esperienze-in-scadenza')}
      title={conteggio ? `${conteggio} esperienze scadute o in preavviso` : 'Esperienze in scadenza'}
      style={{
        position: 'relative',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 6,
        display: 'flex',
        alignItems: 'center',
        color: 'inherit',
        fontSize: 16,
      }}
    >
      <FaBell />
      {conteggio > 0 && (
        <span
          style={{
            position: 'absolute',
            top: 2,
            right: 2,
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: '#C0392B',
          }}
        />
      )}
    </button>
  );
}
